
function slide1_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var banners = '';

  slideReset();
  changeBG("bg1");
  $('#tmi2').removeClass('active');
  $('#tmi3').removeClass('active');
  $('#tmi1').addClass('active');

  bmcont = '<div id="sl1_head"></div><div id="sl1_cnt" class="sl_cnt"></div><div id="sl1_bm1" class="menu_bott_big">';
  pocet = jsondata["sl1_menu1"].length + 1;
  for (i=1; i<pocet; i++) {
    bmcont += '<div class="circle_pos" id="circle_pos_'+i+'" data-clicked="'+i+'"><div class="circle_leash" id="circle_leash_'+i+'"></div><div class="circle_label" id="circle_label_'+i+'">'+jsondata["sl1_menu1"][i-1]+'</div><div class="circle_bg"></div><div class="circle_anim pulsateME"></div><div class="circle" id="circle_'+i+'" data-clicked="'+i+'"><i class="circle_icon icon-'+i+'"></i></div><div class="circle_over" id="circle_over_'+i+'" data-clicked="'+i+'"></div></div>'
  }
  bmcont += '</div>';
  bmcont += '<div id="sl1_bm1" class="menu_bott_small" style="display:none">';
  pocet = jsondata["sl1_menu2"].length + 1;
  for (i=1; i<pocet; i++) {
    bmcont += '<div id="sl1_small'+i+'" class="bmi_small" data-clicked="'+i+'"><div class="bmi_bg_small"></div><div class="bmi_point_small"><i class="number">'+i+'</i></div><div id="small'+i+'_tt" class="bmitt_small">'+jsondata["sl1_menu2"][i-1]+'</div></div>';
  }
  bmcont += '</div>';

  bmcont += '<div id="page2" class="arrowR"><i class="arrow-right"></i></div>';

  $("#slide1").html(bmcont);

  $('#slide1').fadeIn(1000);
  bannerReset();
  loadBanners(1,"sl1_banner1");
  loadBanners(2,"sl1_banner2");

  $(".circle_pos").on("click", function(){
		var id = $(this).attr("id");
    var clickid = $(this).data("clicked");

    bannerReset();
    clickBanner(id,clickid);

    switch (clickid) {
    case 1:
      $(".menu_bott_small").fadeOut();
      $(".bmi_small .bmi_bg_small").show();
      $(".bmi_small .bmi_point_small").removeClass("active");

      $("#"+id+" .circle_bg").hide();
      $("#"+id+" .circle_anim").hide();
      $("#circle_"+clickid).addClass("active");
      $("#circle_"+clickid+" .icon-"+clickid).addClass("active");
      $("#ban_1_"+clickid).fadeIn(100);
      bannerReset();
  		var bannerBox = document.getElementById("ban_1_"+clickid);
  		TweenMax.to(bannerBox, 1, {x:0, y:-400,  ease:Quint.easeOut});
  		TweenMax.to(bannerBox, 0.5, {autoAlpha:1});
    break;
    case 2:
      $("#circle_pos_1 .circle_bg").show();
      $("#circle_pos_1 .circle_anim").show();
      $("#circle_1").removeClass("active");
      $("#circle_1 .icon-1").removeClass("active");
      $(".bmi_small .bmi_point_small").removeClass("active");

      $(".menu_bott_small").fadeIn(200);
      $("#sl1_small1 .bmi_bg_small").hide();
      $("#sl1_small1 .bmi_point_small").addClass("active");
      bannerReset();
      $("#ban_2_1").fadeIn(100);
      var bannerBox = document.getElementById("ban_2_1");
  		TweenMax.to(bannerBox, 1, {x:0, y:-470,  ease:Quint.easeOut});
  		TweenMax.to(bannerBox, 0.5, {autoAlpha:1});
    break;
  };
  });

  $(".bmi_small").on("click", function(){
		var id = $(this).attr("id");
    var clickid = $(this).data("clicked");
    console.log(clickid);
    console.log(id);

    $(".bmi_small .bmi_bg_small").show();
    $(".bmi_small .bmi_point_small").removeClass("active");

    bannerReset();
    clickBanner(id,clickid);

    $("#"+id+" .bmi_bg_small").hide();
    $("#"+id+" .bmi_point_small").addClass("active");
    bannerReset();
    $("#ban_2_"+clickid).fadeIn(100);
    var bannerBox = document.getElementById("ban_2_"+clickid);
    TweenMax.to(bannerBox, 1, {x:0, y:-470,  ease:Quint.easeOut});
    TweenMax.to(bannerBox, 0.5, {autoAlpha:1});

  });

  $("#page2").on("click", function(){

    bannerReset();
    slide2_anima();

  });




}
